import { BudgetProposalT } from 'routes/BudgetModule/config/types';

type BudgetProposalKey = {
    budgetName: string;
    section: string | null;
    exercice: number;
};

/*
 * Find the matching budget proposal
 */
export const getMatchingBudgetProposal = (
    key: BudgetProposalKey,
    budgetProposals: BudgetProposalT[],
    shouldThrowIfNotFound: boolean = false,
): BudgetProposalT | null | undefined => {
    const budgetProposal = budgetProposals.find(
        (bp) =>
            // FIXME: test with section != null
            bp.budgetName === key.budgetName &&
            bp.section === key.section &&
            bp.exercice === key.exercice,
    );
    if (!budgetProposal && shouldThrowIfNotFound) {
        throw new Error('Unable to find matching budget proposal');
    }
    return budgetProposal;
};
